import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import "@/assets/style/index.less";
import mixin from "./mixin/index";
import store from "./store/index";

import "@/components/Vant";
import '@/components/Antd'
// rem
import "amfe-flexible";
// router 守卫 权限
import "./router/permissions"
// import "./utils/common.js"
Vue.mixin(mixin);

// 获取屏幕宽度
Vue.prototype.windowWidth = function() {
    return document.documentElement.clientWidth;
}

Vue.config.productionTip = false;
new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app");